// @flow
import * as React from 'react';
import styled from 'styled-components';
import * as SS from 'styled-system';

const Container = styled(
  ({
    mt,
    mb,
    ml,
    mr,
    mx,
    my,
    pt,
    pb,
    pl,
    pr,
    px,
    py,
    color,
    border,
    borderLeft,
    borderRight,
    borderTop,
    borderBottom,
    borderColor,
    display,
    height,
    width,
    maxWidth,
    verticalAlign,
    ...props
  }) => <div {...props} />
)`
  ${SS.space} ${SS.color} ${SS.borders} ${SS.borderColor} ${SS.display} 
  ${SS.height} ${SS.width} ${SS.maxWidth} ${SS.verticalAlign};
`;

export default Container;
